import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {DataTableModule,SharedModule, ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule} from 'primeng/primeng';

import { CustomerRoutingModule } from './customer-routing.module';
import { CustomerComponent } from './customer.component';
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component';
import { CustomerService } from './customer.service';

@NgModule({
  imports: [
    CommonModule,
    CustomerRoutingModule,
    FormsModule,
    DataTableModule,SharedModule, 
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule
  ],
  declarations: [CustomerComponent, CustomerDetailComponent],
  providers: [CustomerService]
})
export class CustomerModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer/customer.module.ts